export default class DetailsField {
  constructor({ label, value, isNone = false }) {
    this.label = label;
    this.value = value;
    this.isNone = isNone;
  }
}
